/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment-timezone';
import React from 'react';
import { useParams } from 'react-router-dom';
import { getDashboardState } from 'selectors/dashboardEdit';
import { useSelector } from 'store';
import { DashboardWidget as DashboardWidgetType } from 'types';
import { areIntersected } from 'utils/dashboard';
import DashboardEditHeader from './DashboardEditHeader';
import reduceWidgetGroup from './reduceWidgetGroup';
import ReviewWidgetDashboardEditHeader from './ReviewWidgetDashboardEditHeader';

const DashboardEditMode: React.FC = () => {
  const { activeUuid } = useParams<{ activeUuid: string }>();

  const dashboardState = useSelector(getDashboardState(activeUuid || ''));

  const intersected = areIntersected(dashboardState);

  if (dashboardState.primary_timezone) {
    moment.tz.setDefault(dashboardState.primary_timezone);
  }

  return (
    <div className="flex flex-col">
      {dashboardState.widgets[0].widget === 'pending_review_widget' ? (
        <ReviewWidgetDashboardEditHeader />
      ) : (
        <DashboardEditHeader />
      )}
      <div className="mt-3 grid grid-cols-16 auto-rows-layout gap-4 px-8">
        {dashboardState.widgets.reduce<(JSX.Element | DashboardWidgetType)[]>(
          reduceWidgetGroup(intersected, dashboardState.key),
          []
        )}
      </div>
    </div>
  );
};

export default DashboardEditMode;
